<template>
  <div>
    <div class="desc-list" v-for="desc in descList" :key="desc.id">
      <div class="an-head">
        <p class="title">
          <span v-if="!isGroupTitle" class="desc-style">
            <div class="title-box">
              <span class="qu-num" v-if="answerStyleConfig.common.showQuNumInd === '1'">{{config.quCode}}.</span>
              <span v-if="config.answerConfig.requireInd === '1'" class="require">*</span>
              <span class="qu-title" v-html="config.displayTitle"></span>
              <span v-if="answerStyleConfig.common.showQuestionType === '1'" class="qu-type">
                (<span v-html="config.displayElementDesc"></span>)
              </span>
            </div>
            <div v-if="config.imgUrl" class="media-box">
              <ipsos-av v-if="isAv(config.imgUrl)" :src="config.imgUrl"></ipsos-av>
              <ipsos-image v-else :imgUrl="config.imgUrl" :preview="config.id"></ipsos-image>
            </div>
          </span>
        </p>
        <template v-if="groupvisibility()">
          <p class="title desc-style">
            <!-- <span class="qu-num" v-if="answerStyleConfig.common.showQuNumInd === '1'">{{`${config.quCode}.${index + 1}`}}</span> -->
            <span class="option-title" v-html="desc.displayTitle"></span>
          </p>
          <ipsos-av v-if="isAv(desc.imgUrl)" :src="desc.imgUrl"></ipsos-av>
          <ipsos-image v-else :imgUrl="desc.imgUrl" :preview="desc.id"></ipsos-image>
        </template>
      </div>
      <div v-if="groupvisibility()" class="an-body">
        <slot name="optionList">
          <answer-option-list
            :config="config"
            :prop="'descList.'+index+'.value'"
            :answerValidate="answerValidate"
            :crtDescIndex="index"
            :model="desc"
            :optionKey="optionKey"
            :optionValueKey="optionValueKey"
            :multiple="multiple"
          ></answer-option-list>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'AnswerDescList',
  props: ['config', 'optionKey', 'optionValueKey', 'multiple', 'answerValidate'],
  data () {
    return {}
  },
  components: {},
  watch: {},
  computed: {
    ...mapState({
      answerStyleConfig: ({Question}) => Question.answerStyleConfig,
      lang: ({Question}) => Question.lang,
      langMap: ({Question}) => Question.langMap
    }),
    index () {
      return this.config.descIndex
    },
    isGroupTitle () {
      return /^RadioBoxGroup|CheckBoxGroup$/.test(this.config.elementType) && this.index > 0
    },
    descList () {
      const config = this.config
      return config.descList.filter((item, index) => index === config.descIndex)
    }
  },
  methods: {
    isAv (url) {
      return url && url.includes('.mp4')
    },
    groupvisibility () {
      if (this.config.elementType === 'RadioBoxGroup' || this.config.elementType === 'CheckBoxGroup') {
        return this.config.descList[this.config.descIndex].visibility
      } else {
        return true
      }
    }
  },
  created () {
  },
  mounted () {}
}
</script>
<style lang="scss" scoped>
.desc-list {
  .an-head {
    .title {
      margin-top: 30px;
      .desc-style {
        flex-direction: column;
        .media-box {
          margin-top: 15px;
          display: flex;
          justify-content: center;
        }
        .title-box {
          padding-bottom: 40px;
          border-bottom: 1px solid #f1f1f1;
          .require {
            font-size: 36px;
            color: #FF645A;
          }
          .qu-num, .qu-title {
            font-size: 32px;
            font-weight: 500;
            color: #000;
            margin-right: 10px;
          }
          .qu-type {
            color: #bbb;
          }
        }
      }
      .option-title {
        font-size: 28px;
      }
    }
  }
}
.answer-pc {
  .desc-list {
    .an-head {
      .title {
        margin-top: 15px;
        padding: 0 30px;
        .require {
          font-size: 18px;
        }
        .qu-num, .qu-title {
          font-size: 18px;
          margin-right: 5px;
        }
      }
    }
    .an-body {
      padding: 15px 40px 10px 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/answer/AnswerDescList.vue